import React from 'react'
import { StyleSheet, ViewPropTypes, ImageBackground, TouchableOpacity, View } from 'react-native'
import PropTypes from 'prop-types'
import Assets from '../../../../../assets/export'

import Txt from '../../../../components/Txt'
import { useTheme } from '../../../../theming/ThemeProvider'
import { } from 'react-native-gesture-handler'
import { Icon } from '../../../../components'

export default function QuickNumberCard (props) {
  const { title, number, color, style, onPress, testID } = props
  const { theme } = useTheme()

  return (
    <TouchableOpacity
      activeOpacity={0.8}
      style={style}
      onPress={onPress}
      testID={testID}
      accessibilityLabel={testID}
    >
      <ImageBackground
        source={Assets.particles}
        style={[
          styles.card,
          {
            backgroundColor: theme[color]
          }
        ]}
      >
        <Txt
          text={number || number === 0 ? number : ''}
          identity='h3'
          style={[styles.text, { lineHeight: 26 }]}
          color='WHITE_TEXT'
        />
        <Txt
          text={title}
          identity='body2'
          style={[styles.text, { lineHeight: 14 }]}
          color='WHITE_TEXT'
        />
      </ImageBackground>
      <View style={{ position: 'absolute', right: 10, top: 10, opacity: 0.5 }}>
        <Icon
          name='Link'
          width={12}
          height={12}
          fill='white'
        />
      </View>
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  card: {
    borderRadius: 10,
    borderWidth: 0,
    margin: 0,
    padding: 10,
    alignItems: 'center',
    width: '100%',
    overflow: 'hidden'
  },
  text: {
    textAlign: 'center',
    marginBottom: 0
  }
})

QuickNumberCard.propTypes = {
  title: PropTypes.string.isRequired,
  number: PropTypes.number,
  color: PropTypes.string.isRequired,
  style: ViewPropTypes.style,
  onPress: PropTypes.func,
  testID: PropTypes.string
}

QuickNumberCard.defaultProps = {
  title: '',
  number: null,
  color: '',
  style: null,
  onPress: () => {}
}
